import { useEffect } from 'react';

import { useStoreContext } from 'features/store';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { logger } from 'utils/logger';

const LOG_DELAY_MS = 100;
const logTimeoutId = { current: null as NodeJS.Timeout | null };
export const isMessageLogged = { current: false };

export const useMinimalCartUi = () => {
  const enableMinimalCartUiFlag = useFlag(LaunchDarklyFlag.ENABLE_MINIMAL_CART_UI);
  const isUnifiedMenuEnabled = useFlag(LaunchDarklyFlag.ENABLE_UNIFIED_MENU);
  const { store } = useStoreContext();
  const posVendor = store.pos?.vendor?.toLowerCase();

  const enableMinimalCartUi = enableMinimalCartUiFlag && isUnifiedMenuEnabled;
  useEffect(() => {
    if (isMessageLogged.current) {
      return;
    }

    // Wait for deps (flag + store/vendor) to settle before logging to avoid false negatives
    if (!posVendor) {
      return;
    }

    if (logTimeoutId.current) {
      clearTimeout(logTimeoutId.current);
    }

    logTimeoutId.current = setTimeout(() => {
      logger.debug({
        message: `Minimal cart UI ${enableMinimalCartUi ? 'enabled' : 'disabled'}`,
        enableMinimalCartUi,
        enableMinimalCartUiFlag,
        posVendor,
        storeId: store?.number,
      });
      isMessageLogged.current = true;
    }, LOG_DELAY_MS);

    return () => {
      if (logTimeoutId.current) {
        clearTimeout(logTimeoutId.current);
      }
    };
  }, [enableMinimalCartUi, enableMinimalCartUiFlag, posVendor, store?.number]);

  return enableMinimalCartUi && isUnifiedMenuEnabled;
};
